import { ModalOverlay as AriaOverlay, type ModalOverlayProps } from "react-aria-components";
import React from "react";

import { cn } from "@/lib/helpers/cn";

export function ModalOverlay2(props: ModalOverlayProps) {
  return (
    <AriaOverlay
      {...props}
      className={({ isEntering, isExiting }) =>
        cn(
          "tw:fixed tw:inset-0 tw:z-overlay tw:min-h-full tw:w-full",
          "tw:flex tw:items-center tw:justify-center",
          "tw:bg-fill-black/20 tw:backdrop-blur-xs",
          isEntering && "tw:animate-in tw:duration-150 tw:ease-in-out tw:fade-in",
          isExiting && "tw:animate-out tw:duration-150 tw:ease-in-out tw:fade-out",
        )
      }
    />
  );
}
